import React from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippy.js/react';
import { translate } from 'helpers/translateHelper';
import { IconDropDownMo, IconInfo } from 'svgIcons/MotionPortalIcons';
import './style.scss';
import { anomalyChartLegendItems, chartLegendItems, conditionInsightsTabs } from './helpers';

const ConditionInsightsLegend = ({ activeTab, assetDetails, hasDriveAnomalyDetection, isCoolingAnomalyActive }) => {

    const getLegendItems = activeTab === conditionInsightsTabs.CONDITION_INDICES
        ? chartLegendItems(assetDetails) : anomalyChartLegendItems(isCoolingAnomalyActive);

    const tippyContent = () =>
        <div className='chart-legend'>
            {!!getLegendItems?.length && getLegendItems?.map((legendItems, index) =>
                <>
                    <div className='chart-legend-title'>{translate(legendItems.title)}</div>
                    <div className='chart-legend-items' key={`key-legendItems-${index}`}>
                        {legendItems.legends.map((legendItem, index) =>
                            <div
                                className={`legend-item ${legendItem?.className || ''}`}
                                key={`key-legendItem-${index}`}
                            >
                                <div className='legend-icon'>{legendItem?.icon}</div>
                                <div className='legend-text'>{translate(legendItem?.translateKey)}</div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div >;

    return (
        <div className='condition-insight-chart-legend-container'>
            <Tippy
                content={tippyContent()}
                className='info-button-with-online-help-tippy'
                interactive={true}
                interactiveBorder={10}
                animation='scale'
                theme='light-border'
                trigger='click'
                placement='bottom'
                maxWidth='600px'
            >
                <div className='chart-legend-tippy-content'>
                    <IconInfo color='black' aria-label='Chart Legend Info' />
                    <div className='legend-label'>{hasDriveAnomalyDetection && activeTab === conditionInsightsTabs.ANOMALY_DETECTION ? translate('ABB.Powertrain.Frontend.coolingAnomalyLegendButtonText') : translate('ABB.Powertrain.Frontend.advancedAnalitycsLegendButtonText')}</div>
                    <IconDropDownMo width={8} height={16} />
                </div>
            </Tippy>
        </div>
    );
};

ConditionInsightsLegend.propTypes = {
    assetDetails: PropTypes.object,
    hasDriveAnomalyDetection: PropTypes.bool,
    isCoolingAnomalyActive: PropTypes.bool,
    activeTab: PropTypes.string
};

export default ConditionInsightsLegend;
